import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewChild, Input, Output, ViewChildren, Directive, Injectable, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i2 from '@angular/forms';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import * as i3 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as i1$1 from 'bqx-businesstype-requests';
import { BqxBusinesstypeRequestsModule, BusinessTypeRequestsAbstractService, BusinessTypeRequestsService } from 'bqx-businesstype-requests';
import * as i4 from '@angular/material/core';
import { Subject, from, Observable, BehaviorSubject, of } from 'rxjs';
import { takeUntil, map, switchMap, debounceTime, concatMap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BQXConfiguration } from 'bqx-ui-common';

class ChoiceSelectorInputComponent {
    get isInvalid() {
        const result = Boolean(this.paramFormGroup?.get(this.paramFormControlName).invalid
            && (this.errorText && this.errorText.length && this.errorText.length > 0));
        return result;
    }
    // For cases that a label should be shown below, but no options exist.
    // Example case: contractor business type.
    get isOnlyLabel() {
        return (!this.options || this.options[0]?.Text === '');
    }
    constructor(cd) {
        this.cd = cd;
        this.options = [];
        this.optionChange = new EventEmitter();
    }
    ngAfterViewInit() {
        this.cd.detectChanges();
    }
    onChange(text, code) {
        this.optionChange.emit({ becaDisplayLabel: text, code: code });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: ChoiceSelectorInputComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.8", type: ChoiceSelectorInputComponent, selector: "choice-selector-input", inputs: { paramFormGroup: "paramFormGroup", labelText: "labelText", additionalLabelText: "additionalLabelText", errorText: "errorText", paramFormControlName: "paramFormControlName", code: "code", options: "options" }, outputs: { optionChange: "optionChange" }, viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true }], ngImport: i0, template: "<!-- Used as an input for multiple choice questions on the BECA page -->\n<div class=\"bqx-core-choice-selector-field\" [formGroup]=\"paramFormGroup\">\n  <label\n    class=\"bqx-core-choice-selector-lable bqx-core-choice-selector-field-lable\"\n    style=\"display: inline\"\n    id=\"bqx-core-choice-selector-radios-moreinfo-error\"\n    >{{ labelText }}</label\n  >\n  <br />\n  {{ additionalLabelText }}\n  <p class=\"bqx-core-choice-selector-p bqx-core-choice-selector-field-p\" [class.error]=\"isInvalid\">\n    {{ errorText }}\n  </p>\n\n  <!-- Input Field Set -->\n  <div *ngIf=\"!isOnlyLabel\">\n    <fieldset class=\"bqx-core-choice-selector-fieldset\" [attr.aria-label]=\"labelText\" [id]=\"paramFormControlName\" [class.error]=\"isInvalid\">\n      <!-- Individual Option container -->\n      <div class=\"bqx-core-choice-selector-fieldset-div\" *ngFor=\"let option of options\" [class.checked]=\"input.checked\">\n        <!-- Checkbox Input -->\n        <input\n          #input\n          class=\"bqx-core-choice-selector-fieldset-radio-input\"\n          type=\"radio\"\n          [attr.name]=\"paramFormControlName\"\n          [formControlName]=\"paramFormControlName\"\n          [value]=\"option.Value\"\n          [id]=\"option.Value\"\n          (change)=\"onChange(option.Text, code)\"\n          attr.data-cy=\"{{ option.Value }}\"\n        />\n        <!-- Label -->\n        <label class=\"bqx-core-choice-selector-fieldset-lable bqx-core-choice-selector-fieldset-input-lable\" [for]=\"option.Value\">\n          <span class=\"bqx-core-choice-selector-fieldset-span bqx-core-choice-selector-fieldset-input-span\">{{ option.Text }}</span>\n          <p class=\"bqx-core-choice-selector-fieldset-p bqx-core-choice-selector-fieldset-input-p\">{{ option.Description }}</p>\n        </label>\n      </div>\n    </fieldset>\n  </div>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.RadioControlValueAccessor, selector: "input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]", inputs: ["name", "formControlName", "value"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: ChoiceSelectorInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'choice-selector-input', template: "<!-- Used as an input for multiple choice questions on the BECA page -->\n<div class=\"bqx-core-choice-selector-field\" [formGroup]=\"paramFormGroup\">\n  <label\n    class=\"bqx-core-choice-selector-lable bqx-core-choice-selector-field-lable\"\n    style=\"display: inline\"\n    id=\"bqx-core-choice-selector-radios-moreinfo-error\"\n    >{{ labelText }}</label\n  >\n  <br />\n  {{ additionalLabelText }}\n  <p class=\"bqx-core-choice-selector-p bqx-core-choice-selector-field-p\" [class.error]=\"isInvalid\">\n    {{ errorText }}\n  </p>\n\n  <!-- Input Field Set -->\n  <div *ngIf=\"!isOnlyLabel\">\n    <fieldset class=\"bqx-core-choice-selector-fieldset\" [attr.aria-label]=\"labelText\" [id]=\"paramFormControlName\" [class.error]=\"isInvalid\">\n      <!-- Individual Option container -->\n      <div class=\"bqx-core-choice-selector-fieldset-div\" *ngFor=\"let option of options\" [class.checked]=\"input.checked\">\n        <!-- Checkbox Input -->\n        <input\n          #input\n          class=\"bqx-core-choice-selector-fieldset-radio-input\"\n          type=\"radio\"\n          [attr.name]=\"paramFormControlName\"\n          [formControlName]=\"paramFormControlName\"\n          [value]=\"option.Value\"\n          [id]=\"option.Value\"\n          (change)=\"onChange(option.Text, code)\"\n          attr.data-cy=\"{{ option.Value }}\"\n        />\n        <!-- Label -->\n        <label class=\"bqx-core-choice-selector-fieldset-lable bqx-core-choice-selector-fieldset-input-lable\" [for]=\"option.Value\">\n          <span class=\"bqx-core-choice-selector-fieldset-span bqx-core-choice-selector-fieldset-input-span\">{{ option.Text }}</span>\n          <p class=\"bqx-core-choice-selector-fieldset-p bqx-core-choice-selector-fieldset-input-p\">{{ option.Description }}</p>\n        </label>\n      </div>\n    </fieldset>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { input: [{
                type: ViewChild,
                args: ['input']
            }], paramFormGroup: [{
                type: Input
            }], labelText: [{
                type: Input
            }], additionalLabelText: [{
                type: Input
            }], errorText: [{
                type: Input
            }], paramFormControlName: [{
                type: Input
            }], code: [{
                type: Input
            }], options: [{
                type: Input
            }], optionChange: [{
                type: Output
            }] } });

class SearchAutocompleteInputComponent {
    constructor() {
        this.selectedOption = new EventEmitter();
        this.focusFallBack = new EventEmitter();
    }
    // Used in template
    get isInvalid() {
        return this.paramFormGroup?.get(this.paramFormControlName).invalid && this.paramFormGroup.get(this.paramFormControlName).touched;
    }
    get pattern() {
        return '^[^<>%\\|~*^\\\\_=\\{\\}\\[\\]]*$';
    }
    ngAfterViewInit() {
        this.input.nativeElement.focus();
    }
    onOptionSelected(matOption) {
        this.selectedOption.emit(matOption);
    }
    onFocus() {
        this.focusFallBack.emit('Fallback');
    }
    // Returns the text to display in the options list
    choiceText(choice) {
        return (this.alias)
            ? choice.Text
            : choice.Value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: SearchAutocompleteInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.8", type: SearchAutocompleteInputComponent, selector: "search-autocomplete-input", inputs: { errorText: "errorText", customError: "customError", alias: "alias", require: "require", multiple: "multiple", paramFormGroup: "paramFormGroup", paramFormControlName: "paramFormControlName", filteredChoices: "filteredChoices" }, outputs: { selectedOption: "selectedOption", focusFallBack: "focusFallBack" }, viewQueries: [{ propertyName: "autocomplete", first: true, predicate: ["autocomplete"], descendants: true }, { propertyName: "input", first: true, predicate: ["fallBackList"], descendants: true }], ngImport: i0, template: "<div class=\"bqx-core-search-text-div\" *ngIf=\"isInvalid\">\n  <p class=\"bqx-core-search-text-p-invalid\" [class.error]=\"isInvalid\">{{ errorText }}</p>\n</div>\n<div class=\"bqx-core-search-text-div\" *ngIf=\"customError\">\n  <p class=\"bqx-core-search-text-error\">{{ customError }}</p>\n</div>\n<div class=\"bqx-core-search-autocomplete-field-div\" [formGroup]=\"paramFormGroup\">\n  <p class=\"bqx-core-search-autocomplete-field-p\" *ngIf=\"!require\">(Optional)</p>\n  <input\n    class=\"bqx-core-search-autocomplete-field-input\"\n    type=\"text\"\n    id=\"fallBackList\"\n    #fallBackList\n    placeholder=\"Pick one\"\n    aria-label=\"Number\"\n    #matInput\n    [matAutocomplete]=\"auto\"\n    [formControlName]=\"paramFormControlName\"\n    [attr.aria-labelledby]=\"paramFormControlName\"\n    data-cy=\"fallBackList\"\n    [pattern]=\"pattern\"\n    [class.error]=\"isInvalid\"\n    (focus)=\"onFocus()\"\n  />\n  <mat-autocomplete\n    [id]=\"paramFormControlName\"\n    class=\"bqx-core-search-autocomplete-field-mat-autocomplete bqx-core-search-autocomplete-mat-autocomplete\"\n    #auto\n    (optionSelected)=\"onOptionSelected($event.option)\"\n  >\n    <mat-option\n      class=\"bqx-core-search-autocomplete-field-mat-option bqx-core-search-autocomplete-mat-option\"\n      *ngFor=\"let option of filteredChoices | async\"\n      [value]=\"option.Value\"\n    >\n      <span class=\"bqx-core-search-autocomplete-field-mat-span bqx-core-search-autocomplete-span\" *ngIf=\"alias; else justValue\">\n        <b>{{ option.Value }}</b\n        >: {{ choiceText(option) }}\n      </span>\n      <ng-template #justValue>\n        <span class=\"bqx-core-search-autocomplete-field-mat-span bqx-core-search-autocomplete-span\">\n          {{ option.Value }}\n        </span>\n      </ng-template>\n    </mat-option>\n  </mat-autocomplete>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.PatternValidator, selector: "[pattern][formControlName],[pattern][formControl],[pattern][ngModel]", inputs: ["pattern"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i3.MatAutocomplete, selector: "mat-autocomplete", inputs: ["aria-label", "aria-labelledby", "displayWith", "autoActiveFirstOption", "autoSelectActiveOption", "requireSelection", "panelWidth", "disableRipple", "class", "hideSingleSelectionIndicator"], outputs: ["optionSelected", "opened", "closed", "optionActivated"], exportAs: ["matAutocomplete"] }, { kind: "component", type: i4.MatOption, selector: "mat-option", inputs: ["value", "id", "disabled"], outputs: ["onSelectionChange"], exportAs: ["matOption"] }, { kind: "directive", type: i3.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", inputs: ["matAutocomplete", "matAutocompletePosition", "matAutocompleteConnectedTo", "autocomplete", "matAutocompleteDisabled"], exportAs: ["matAutocompleteTrigger"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: SearchAutocompleteInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'search-autocomplete-input', template: "<div class=\"bqx-core-search-text-div\" *ngIf=\"isInvalid\">\n  <p class=\"bqx-core-search-text-p-invalid\" [class.error]=\"isInvalid\">{{ errorText }}</p>\n</div>\n<div class=\"bqx-core-search-text-div\" *ngIf=\"customError\">\n  <p class=\"bqx-core-search-text-error\">{{ customError }}</p>\n</div>\n<div class=\"bqx-core-search-autocomplete-field-div\" [formGroup]=\"paramFormGroup\">\n  <p class=\"bqx-core-search-autocomplete-field-p\" *ngIf=\"!require\">(Optional)</p>\n  <input\n    class=\"bqx-core-search-autocomplete-field-input\"\n    type=\"text\"\n    id=\"fallBackList\"\n    #fallBackList\n    placeholder=\"Pick one\"\n    aria-label=\"Number\"\n    #matInput\n    [matAutocomplete]=\"auto\"\n    [formControlName]=\"paramFormControlName\"\n    [attr.aria-labelledby]=\"paramFormControlName\"\n    data-cy=\"fallBackList\"\n    [pattern]=\"pattern\"\n    [class.error]=\"isInvalid\"\n    (focus)=\"onFocus()\"\n  />\n  <mat-autocomplete\n    [id]=\"paramFormControlName\"\n    class=\"bqx-core-search-autocomplete-field-mat-autocomplete bqx-core-search-autocomplete-mat-autocomplete\"\n    #auto\n    (optionSelected)=\"onOptionSelected($event.option)\"\n  >\n    <mat-option\n      class=\"bqx-core-search-autocomplete-field-mat-option bqx-core-search-autocomplete-mat-option\"\n      *ngFor=\"let option of filteredChoices | async\"\n      [value]=\"option.Value\"\n    >\n      <span class=\"bqx-core-search-autocomplete-field-mat-span bqx-core-search-autocomplete-span\" *ngIf=\"alias; else justValue\">\n        <b>{{ option.Value }}</b\n        >: {{ choiceText(option) }}\n      </span>\n      <ng-template #justValue>\n        <span class=\"bqx-core-search-autocomplete-field-mat-span bqx-core-search-autocomplete-span\">\n          {{ option.Value }}\n        </span>\n      </ng-template>\n    </mat-option>\n  </mat-autocomplete>\n</div>\n" }]
        }], propDecorators: { autocomplete: [{
                type: ViewChild,
                args: ['autocomplete']
            }], input: [{
                type: ViewChild,
                args: ['fallBackList']
            }], errorText: [{
                type: Input
            }], customError: [{
                type: Input
            }], alias: [{
                type: Input
            }], require: [{
                type: Input
            }], multiple: [{
                type: Input
            }], paramFormGroup: [{
                type: Input
            }], paramFormControlName: [{
                type: Input
            }], filteredChoices: [{
                type: Input
            }], selectedOption: [{
                type: Output
            }], focusFallBack: [{
                type: Output
            }] } });

class SearchTextInputComponent {
    static { this.required = true; }
    get required() {
        return SearchTextInputComponent.required;
    }
    constructor(cd) {
        this.cd = cd;
        this._becaTextUnsub$ = new Subject();
        this.onReset = new EventEmitter();
        this.focusBeca = new EventEmitter();
    }
    // Used in template
    get isInvalid() {
        return this.paramFormGroup?.get(this.paramFormControlName).invalid && this.paramFormGroup.get(this.paramFormControlName).touched;
    }
    get pattern() {
        return '^[^<>%\\|~*^\\\\_=\\{\\}\\[\\]]*$';
    }
    emitResetEvent(event) {
        this.onReset.emit(event);
    }
    onFocus() {
        this.focusBeca.emit('BECA');
    }
    ngAfterViewInit() {
        this.cd.detectChanges();
        this.buttons.changes
            .pipe(takeUntil(this._becaTextUnsub$))
            .subscribe((result) => {
            if (document.activeElement.id == 'searchbtn' || document.activeElement.id == 'resetbtn') {
                setTimeout(() => {
                    result.last.nativeElement.focus();
                }, 0);
            }
        }, (err) => {
            this._becaTextUnsub$.next();
            this._becaTextUnsub$.complete();
            throw new Error(err);
        });
    }
    ngOnDestroy() {
        this._becaTextUnsub$.next();
        this._becaTextUnsub$.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: SearchTextInputComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.8", type: SearchTextInputComponent, selector: "search-text-input", inputs: { errorText: "errorText", customError: "customError", paramFormGroup: "paramFormGroup", paramFormControlName: "paramFormControlName", submitButtonText: "submitButtonText", resetButtonText: "resetButtonText", showSubmitButton: "showSubmitButton" }, outputs: { onReset: "onReset", focusBeca: "focusBeca" }, viewQueries: [{ propertyName: "textInput", first: true, predicate: ["textInput"], descendants: true }, { propertyName: "buttons", predicate: ["buttons"], descendants: true }], ngImport: i0, template: "<div class=\"bqx-core-search-text-div\" *ngIf=\"isInvalid\">\n  <p class=\"bqx-core-search-text-p-invalid\" [class.error]=\"isInvalid\">{{ errorText }}</p>\n</div>\n<div class=\"bqx-core-search-text-div\" *ngIf=\"customError\">\n  <p class=\"bqx-core-search-text-error\">{{ customError }}</p>\n</div>\n<div class=\"bqx-core-search-text-formGroup-div\" [formGroup]=\"paramFormGroup\">\n  <p class=\"bqx-core-search-text-formGroup-p\" *ngIf=\"!required\">(Optional)</p>\n  <input\n    #textInput\n    id=\"beccaSearch\"\n    class=\"bqx-core-search-text-formGroup-input\"\n    [class.error]=\"isInvalid\"\n    type=\"text\"\n    [formControlName]=\"paramFormControlName\"\n    placeholder=\"Search\"\n    [required]=\"required\"\n    data-cy=\"textSearch\"\n    [pattern]=\"pattern\"\n    (focus)=\"onFocus()\"\n  />\n  <ng-container #buttons>\n    <button\n      #buttons\n      #submitButton\n      id=\"searchbtn\"\n      *ngIf=\"showSubmitButton; else showResetButton\"\n      class=\"bqx-core-search-text-formGroup-button bqx-core-search-text-formGroup-search-button\"\n      [disabled]=\"isInvalid\"\n      data-cy=\"searchbtn\"\n    >\n      <span class=\"bqx-core-search-text-formGroup-button-label\">{{ submitButtonText }}</span>\n    </button>\n    <ng-template #showResetButton>\n      <button\n        #buttons\n        id=\"resetbtn\"\n        data-cy=\"resetbtn\"\n        type=\"button\"\n        class=\"bqx-core-search-text-formGroup-button bqx-core-search-text-formGroup-clear-button\"\n        (click)=\"emitResetEvent($event)\"\n      >\n        <span class=\"bqx-core-search-text-formGroup-button-label\">{{ resetButtonText }}</span>\n      </button>\n    </ng-template>\n  </ng-container>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2.PatternValidator, selector: "[pattern][formControlName],[pattern][formControl],[pattern][ngModel]", inputs: ["pattern"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: SearchTextInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'search-text-input', template: "<div class=\"bqx-core-search-text-div\" *ngIf=\"isInvalid\">\n  <p class=\"bqx-core-search-text-p-invalid\" [class.error]=\"isInvalid\">{{ errorText }}</p>\n</div>\n<div class=\"bqx-core-search-text-div\" *ngIf=\"customError\">\n  <p class=\"bqx-core-search-text-error\">{{ customError }}</p>\n</div>\n<div class=\"bqx-core-search-text-formGroup-div\" [formGroup]=\"paramFormGroup\">\n  <p class=\"bqx-core-search-text-formGroup-p\" *ngIf=\"!required\">(Optional)</p>\n  <input\n    #textInput\n    id=\"beccaSearch\"\n    class=\"bqx-core-search-text-formGroup-input\"\n    [class.error]=\"isInvalid\"\n    type=\"text\"\n    [formControlName]=\"paramFormControlName\"\n    placeholder=\"Search\"\n    [required]=\"required\"\n    data-cy=\"textSearch\"\n    [pattern]=\"pattern\"\n    (focus)=\"onFocus()\"\n  />\n  <ng-container #buttons>\n    <button\n      #buttons\n      #submitButton\n      id=\"searchbtn\"\n      *ngIf=\"showSubmitButton; else showResetButton\"\n      class=\"bqx-core-search-text-formGroup-button bqx-core-search-text-formGroup-search-button\"\n      [disabled]=\"isInvalid\"\n      data-cy=\"searchbtn\"\n    >\n      <span class=\"bqx-core-search-text-formGroup-button-label\">{{ submitButtonText }}</span>\n    </button>\n    <ng-template #showResetButton>\n      <button\n        #buttons\n        id=\"resetbtn\"\n        data-cy=\"resetbtn\"\n        type=\"button\"\n        class=\"bqx-core-search-text-formGroup-button bqx-core-search-text-formGroup-clear-button\"\n        (click)=\"emitResetEvent($event)\"\n      >\n        <span class=\"bqx-core-search-text-formGroup-button-label\">{{ resetButtonText }}</span>\n      </button>\n    </ng-template>\n  </ng-container>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { textInput: [{
                type: ViewChild,
                args: ['textInput']
            }], buttons: [{
                type: ViewChildren,
                args: ['buttons']
            }], errorText: [{
                type: Input
            }], customError: [{
                type: Input
            }], paramFormGroup: [{
                type: Input
            }], paramFormControlName: [{
                type: Input
            }], submitButtonText: [{
                type: Input
            }], resetButtonText: [{
                type: Input
            }], showSubmitButton: [{
                type: Input
            }], onReset: [{
                type: Output
            }], focusBeca: [{
                type: Output
            }] } });

class BusinessTypeHostDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BusinessTypeHostDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.8", type: BusinessTypeHostDirective, selector: "[businessTypeHost]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BusinessTypeHostDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[businessTypeHost]',
                }]
        }], ctorParameters: () => [{ type: i0.ViewContainerRef }] });

var FallbackReason;
(function (FallbackReason) {
    FallbackReason["responseBody"] = "Invalid ResponseBody from Primary data source.";
    FallbackReason["userDefObj"] = "Primary data source may be down. Specific details added at runtime.";
    FallbackReason["isForTextInput"] = "Invalid response_type from Primary data source.";
    FallbackReason["twoCallsFailed"] = "2 Calls to Primary data source API failed.";
    FallbackReason["getBusinessTypesFromSearchPhrase"] = "Invalid searchPhrase string.";
    FallbackReason["parseMainQuestion"] = "Main question text could not be parsed.";
    FallbackReason["parseBusinessCategories"] = "Business Category Options could not be parsed.";
    FallbackReason["parseFinalClassLabel"] = "Specific details added at runtime.";
    FallbackReason["parseFinalClassDescription"] = "Specific details added at runtime.";
    FallbackReason["dataSourceError"] = "Primary data source Error other than invalid session.";
    FallbackReason["selectBusinessClassification"] = "Invalid Business Classification string.";
    FallbackReason["incrementSearchesFailed"] = "Maximum number of allowable failed searches exceeded.";
    FallbackReason["listOfOne"] = "List did not contain exactly one match.";
    FallbackReason["choicesLength"] = "No choices available.";
    FallbackReason["choices"] = "Invalid array of choices.";
})(FallbackReason || (FallbackReason = {}));
var BecaResponseType;
(function (BecaResponseType) {
    BecaResponseType["textInput"] = "text_input";
    BecaResponseType["multipleChoice"] = "multiple_choice";
    BecaResponseType["finalClassification"] = "final_classification";
})(BecaResponseType || (BecaResponseType = {}));
var BusinessTypeComponentHost;
(function (BusinessTypeComponentHost) {
    BusinessTypeComponentHost["CLBECA"] = "CLBECA";
})(BusinessTypeComponentHost || (BusinessTypeComponentHost = {}));
var RequestType;
(function (RequestType) {
    RequestType["INIT"] = "INIT";
    RequestType["SEARCH"] = "SEARCH";
    RequestType["SELECT"] = "SELECT";
    RequestType["CLEAN"] = "CLEAN";
})(RequestType || (RequestType = {}));

class BqxComponentLoaderService {
    constructor(cfr) {
        this.cfr = cfr;
    }
    forChild(vcr, cl) {
        return from(cl.loadChildren()).pipe(map((component) => this.cfr.resolveComponentFactory(component)), map(componentFactory => vcr.createComponent(componentFactory)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BqxComponentLoaderService, deps: [{ token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BqxComponentLoaderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BqxComponentLoaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i0.ComponentFactoryResolver }] });

class BusinessTypeComponent {
    constructor(componentLoader, cd) {
        this.componentLoader = componentLoader;
        this.cd = cd;
        this.showPrimaryBusinessType$ = new Observable();
        this.outputEvent = new EventEmitter();
        this._destroyLoaderSubject$ = new Subject();
    }
    ngOnInit() {
        this.loadComponent();
    }
    ngAfterViewInit() {
        this.cd.detectChanges();
    }
    loadComponent() {
        const viewContainerRef = this.businessTypeHost.viewContainerRef;
        viewContainerRef.clear();
        this.componentLoader
            .forChild(viewContainerRef, {
            loadChildren: this.getComponent()
        })
            .pipe(takeUntil(this._destroyLoaderSubject$))
            .subscribe((child) => {
            this.setComponent(child);
        }, (err) => {
            //TODO: Logging
            console.log('Componnet Loader Error: ', err);
        });
    }
    getComponent() {
        switch (this.hostType) {
            case BusinessTypeComponentHost.CLBECA: {
                return () => Promise.resolve().then(function () { return bqxBusinesstypeClBeca_component; }).then((m) => m.BusinessTypeClBecaComponent);
            }
            default: {
                //We throw an error for no host type provided.
                //TODO : Logging
                console.log('Componnet Loader Error: ', 'No Host Type Provided.');
                throw new Error('Componnet Loader Error: No Host Type Provided.');
            }
        }
    }
    setComponent(componentRef) {
        switch (this.hostType) {
            case BusinessTypeComponentHost.CLBECA: {
                const childComponent = componentRef.instance;
                childComponent.data$.next(this.data);
                childComponent.showPrimaryBusinessType$ = this.showPrimaryBusinessType$;
                childComponent.onFinalClassificationChange.subscribe((emitData) => {
                    const event = {
                        type: 'FinalClassificationChange',
                        isFallback: emitData.isFallback,
                        data: emitData.value
                    };
                    this.outputEvent.emit(event);
                });
                childComponent.clearButtonPress.subscribe((emitData) => {
                    const event = {
                        type: 'ClearButtonChange',
                        isFallback: false,
                        data: emitData
                    };
                    this.outputEvent.emit(event);
                });
                childComponent.textChange.subscribe((emitData) => {
                    const event = {
                        type: 'TextChange',
                        isFallback: false,
                        data: emitData
                    };
                    this.outputEvent.emit(event);
                });
                childComponent.onFocusEmitter.subscribe((emitData) => {
                    const event = {
                        type: 'FocusChangeEvent',
                        isFallback: null,
                        data: emitData
                    };
                    this.outputEvent.emit(event);
                });
                childComponent.onBecaResultChange.subscribe((emitData) => {
                    const event = {
                        type: 'BecaResultChange',
                        isFallback: emitData.isFallback,
                        data: emitData.value
                    };
                    this.outputEvent.emit(event);
                });
                break;
            }
            default: {
                const childComponent = componentRef.instance;
                childComponent.data$.next(this.data);
                childComponent.finalClassification.subscribe((emitData) => {
                    this.outputEvent.emit(emitData);
                });
                break;
            }
        }
    }
    ngOnDestroy() {
        this._destroyLoaderSubject$.next();
        this._destroyLoaderSubject$.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BusinessTypeComponent, deps: [{ token: BqxComponentLoaderService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.8", type: BusinessTypeComponent, selector: "business-type-component", inputs: { hostType: "hostType", data: "data", showPrimaryBusinessType$: "showPrimaryBusinessType$" }, outputs: { outputEvent: "outputEvent" }, viewQueries: [{ propertyName: "businessTypeHost", first: true, predicate: BusinessTypeHostDirective, descendants: true, static: true }], ngImport: i0, template: '<ng-template businessTypeHost></ng-template>', isInline: true, dependencies: [{ kind: "directive", type: BusinessTypeHostDirective, selector: "[businessTypeHost]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BusinessTypeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'business-type-component', template: '<ng-template businessTypeHost></ng-template>' }]
        }], ctorParameters: () => [{ type: BqxComponentLoaderService }, { type: i0.ChangeDetectorRef }], propDecorators: { hostType: [{
                type: Input
            }], data: [{
                type: Input
            }], showPrimaryBusinessType$: [{
                type: Input
            }], outputEvent: [{
                type: Output
            }], businessTypeHost: [{
                type: ViewChild,
                args: [BusinessTypeHostDirective, { static: true }]
            }] } });

class FailOverMappingText {
    static { this.NO_CLASSIFICATIONS_TEXT = 'couldn\'t find anything'; }
    static { this.MORE_SPECIFIC_PC = 'be more specific'; }
    static { this.TRY_SEARCH_AGAIN_PC = 'Try your search again'; }
    static { this.MORE_SPECIFIC_TEXT = 'Please be more specific regarding what type of contracting you do:'; }
    static { this.TRY_SEARCH_AGAIN_TEXT = 'Try your search again in the field above using a different, more descriptive phrase or by incorporating more specific keywords'; }
    static { this.SEARCH_STD_ERR_TXT = 'Please search your business type.'; }
    static { this.MULT_CHOICE_ERR_MSG = 'If you can’t find your business type, please call us.'; }
    static { this.SESSION_RENEW_TXT = 'Something went wrong. Please continue by selecting your business type.'; }
    static { this.ANSWER_QUESTION_CODE = 'progressive_commercial_naics'; }
    static { this.FALLBACK_PICKLIST_LABEL = 'Business Type'; }
    static { this.FALLBACK_PICKLIST_SECONDARY_LABEL = 'Having trouble finding your business? Please call '; }
    static { this.FALLBACK_ASSITANCE_PHONE = '1-855-640-9310'; }
    static { this.PRIMARY_SOURCE_INVALID_SESSION = 'Invalid Session'; }
}

class BqxBusinessTypeCLBecaComponentService {
    static { this.BREAK_SESSION = false; }
    get pageInputs() {
        return this._pageInputs;
    }
    get inFallbackMode$() {
        return this._inFallbackMode$;
    }
    get fallbackQuestion() {
        return this._fallbackQuestion;
    }
    get fallbackControlKey() {
        return this._fallbackControlKey;
    }
    get fallbackFilteredOptions() {
        return this._fallbackFilteredOptions;
    }
    get currentBecaResult$() {
        return this._currentClBecaResponse$;
    }
    get finalClassification$() {
        return this._finalClassification$;
    }
    constructor(businessTypeRequestsService) {
        this.businessTypeRequestsService = businessTypeRequestsService;
        this._initDataServiceUnsub = new Subject();
        this._countInitCallsFailed = 0;
        this._formcontrolUnsub = new Subject();
        this._searchBusinessTypesUnsub = new Subject();
        this._onSelectBusinessTypesUnsub = new Subject();
        this._searchesFailed = 0;
        this._clearUnsub = new Subject();
        this._inFallbackMode$ = new BehaviorSubject(false);
        this._finalClassification$ = new BehaviorSubject(null);
        this._currentClBecaResponse$ = new BehaviorSubject(null);
        this.initialOptions = [];
        //this.initControlGroup();
        this._maxInitCallsAllowed = BQXConfiguration.data.businessTypeInvalidSessionCount;
        this._maxSearchCallsAllowed = BQXConfiguration.data.businessTypeInvalidSearchCount;
    }
    initControlGroup() {
        this._businessTypeRequest = this.businessTypeRequestsService.businessTypeRequest.primary;
        this._SecondaryBusinessTypeRequest = this.businessTypeRequestsService.businessTypeRequest.secondary;
        this._pageInputs = {
            shouldDisplay: false,
            formGroup: null,
            searchTextQuestionLablel: '',
            searchTextQuestionSecondaryLabel: '',
            searchTextQuestionErrorLabel: '',
            searchTextErrorLabel: '',
            fallbackPickListMainLabel: FailOverMappingText.FALLBACK_PICKLIST_LABEL,
            fallbackPickListSecondaryLabel: FailOverMappingText.FALLBACK_PICKLIST_SECONDARY_LABEL,
            fallbackAssistancePhone: FailOverMappingText.FALLBACK_ASSITANCE_PHONE,
            selectorQuestions: [],
            mayContinue: false,
            allowSearch: false
        };
        this._formControlIndex = 0;
        this._searchesFailed = 0;
        this._lastSearchText = '';
        this._fallbackQuestion = null;
        // this.displaySessionRenewalText = false;
    }
    Initialize(option) {
        this.initControlGroup();
        const { access_token, request_data, clBeca_rootnode } = option;
        this._serviceData = { data: request_data, clBeca_rootnode };
        this._accessToken = access_token;
        const shouldInitForm = true;
        try {
            this.initBusinessTypeClient(shouldInitForm);
        }
        catch (Error) {
            this.handleInvalidSession('Initialize failed');
        }
    }
    setAllowSearch(allow) {
        this._pageInputs.allowSearch = allow;
        if (this._pageInputs.formGroup.get(this.getFormControlKey(1))) {
            const searchControl = this._pageInputs.formGroup.get(this.getFormControlKey(1));
            if (searchControl) {
                if (allow && !searchControl.enabled) {
                    searchControl.enable();
                    searchControl.markAsTouched();
                }
            }
        }
    }
    onSearch() {
        // If searches are not allowed, then a search should not be performed (API would generate an unrecoverable error if it were.)
        if (!this._pageInputs.allowSearch) {
            return;
        }
        const searchControl = 
        // eslint-disable-next-line valid-typeof
        typeof this._pageInputs.formGroup.get(this.getFormControlKey(1)) !== undefined
            ? this._pageInputs.formGroup.get(this.getFormControlKey(1))
            : null;
        if (!searchControl) {
            return;
        }
        let searchText = searchControl.value;
        if (!searchText || (searchText && searchText.length && searchText.length <= 0)) {
            return;
        }
        searchText = searchText.trim();
        if (!searchText || (searchText && searchText.length && searchText.length <= 0)) {
            return;
        }
        // Cannot search the same text twice (search is deterministic)
        else if (this._lastSearchText === searchText) {
            return;
        }
        else {
            this._lastSearchText = searchText;
        }
        // Just for testing invalid sessions
        if (BqxBusinessTypeCLBecaComponentService.BREAK_SESSION) {
            this.breakSession();
        }
        this.resetBusinessTypeSearch();
        this.seachBusinessTypeFromPrimarySource(this._lastSearchText)
            .pipe(takeUntil(this._searchBusinessTypesUnsub))
            .subscribe((primarySourceResponse) => {
            this.processPrimaryResponseOnSearch(primarySourceResponse);
            this._searchBusinessTypesUnsub.next();
            this._searchBusinessTypesUnsub.complete();
        }, (primarySourceErr) => {
            if (this.isInvalidSession(primarySourceErr)) {
                this.handleInvalidSession(`Invalid ClBeca Session. Details: ${primarySourceErr['message']}`);
            }
            else {
                this.fallbackToSecondaryDataSource(FallbackReason.dataSourceError);
            }
            this._searchBusinessTypesUnsub.next();
            this._searchBusinessTypesUnsub.complete();
        });
    }
    onClear() {
        this.clearSession();
        this.resetBusinessTypeSearch();
        // Clear search input
        this._pageInputs.formGroup.controls[this.getFormControlKey(1)].setValue('');
    }
    clearQuestions(event) {
        this._optionText = event.becaDisplayLabel;
        const count = this._pageInputs.selectorQuestions.length;
        const index = this._pageInputs.selectorQuestions.findIndex((item) => item.Code == event.code);
        if (index < count - 1) {
            //only remove questions if sub questions exist
            this._pageInputs.selectorQuestions.splice(index + 1, count - (index + 1));
        }
    }
    getFormControlKey(index) {
        return 'FormControl_' + (index ? index : this._formControlIndex);
    }
    onFallbackOptionSelected(matOption) {
        this._finalClassification$.next({ becaDisplayLabel: this._optionText, code: matOption.value });
    }
    clearSession() {
        //TODO: Body generation is bit of harcoded here as we are using AWS ClBeca Wrapper API
        //I saw some BQX Consumer UI specific terminologies is being used in AWS ClBeca Wrapper API that needs to updated..
        const clearOption = this.createClBecaRequest(RequestType.CLEAN, 'StartOver');
        this._businessTypeRequest
            .cleanSearchHistory(clearOption)
            .pipe(takeUntil(this._clearUnsub))
            .subscribe((clearResponseBody) => {
            this.processPrimaryResponseOnSearch(clearResponseBody);
            this._clearUnsub.next();
            this._clearUnsub.complete();
        }, (clearResponseError) => {
            if (this.isInvalidSession(clearResponseError)) {
                this.handleInvalidSession(`Invalid ClBeca Session. Details: ${clearResponseError['message']}`);
            }
            this._clearUnsub.next();
            this._clearUnsub.complete();
        });
    }
    initBusinessTypeClient(shouldInitForm) {
        try {
            const primaryOption = this.createClBecaRequest(RequestType.INIT);
            this._businessTypeRequest
                .initDataService(primaryOption)
                .pipe(takeUntil(this._initDataServiceUnsub))
                .subscribe((primarySourceResponse) => {
                if (primarySourceResponse && primarySourceResponse.context && primarySourceResponse.context.conversation_id) {
                    this._context = primarySourceResponse.context;
                    if (shouldInitForm) {
                        this.initializeFormGroup();
                    }
                    //this.displaySessionRenewalText = false; TODO:
                    this._initDataServiceUnsub.next();
                    this._initDataServiceUnsub.complete();
                    this.processPrimaryResponseOnInit(primarySourceResponse);
                }
                else {
                    this._initDataServiceUnsub.next();
                    this._initDataServiceUnsub.complete();
                    this.fallbackToSecondaryDataSource(FallbackReason.responseBody);
                }
            }, (primarySourceError) => {
                this._initDataServiceUnsub.next();
                this._initDataServiceUnsub.complete();
                this.fallbackToSecondaryDataSource(FallbackReason.responseBody);
            });
        }
        catch (error) {
            this._initDataServiceUnsub.next();
            this._initDataServiceUnsub.complete();
            throw error;
        }
    }
    processPrimaryResponseOnInit(primarySourceResponse) {
        this._currentClBecaResponse$.next({ value: primarySourceResponse, isFallback: this._inFallbackMode$.value });
        const userDefObj = this.getBecaResponseObj(primarySourceResponse);
        if (userDefObj instanceof Error) {
            FallbackReason.userDefObj = userDefObj.message;
            this.fallbackToSecondaryDataSource(FallbackReason.userDefObj);
        }
        else {
            if (this.isTextInputResponseValid(userDefObj)) {
                // If there was already a main question label of any length, then there was already a session, so the label should be updated accordingly
                if (this._pageInputs.searchTextQuestionLablel !== undefined &&
                    this._pageInputs.searchTextQuestionLablel.length !== undefined &&
                    this._pageInputs.searchTextQuestionLablel.length > 0) {
                    // If there's still searchtext, then the session was just renewed, so perform the search again
                    if (this._lastSearchText && this._lastSearchText.length && this._lastSearchText.length > 0) {
                        /* Since formControlIndex counts the number of created forms,
                        if more than one form control was created, then at least one multiple-choice question was displayed,
                        meaning that that question (and the user's just-selected answer) is going to get purged.
                        Thus the user needs to see the message. */
                        if (this._formControlIndex > 1) {
                            // this.displaySessionRenewalText = true; TODO:
                        }
                        this.setAllowSearch(true);
                        this._lastSearchText = '';
                        this.onSearch();
                    }
                }
                else {
                    this._pageInputs.searchTextQuestionLablel = userDefObj.text;
                    this._pageInputs.searchTextQuestionSecondaryLabel = userDefObj.additional_description ? userDefObj.additional_description : '';
                }
                // Searches are allowed now
                this.setAllowSearch(true);
                // this.lastSearchText should be blank right now anyways
                this._pageInputs.shouldDisplay = true;
            }
            else {
                this.fallbackToSecondaryDataSource(FallbackReason.isForTextInput);
            }
        }
    }
    // Sets up the user input form, using Angular Forms
    initializeFormGroup() {
        // Create new empty form controls dictionary
        const formControlsGroup = {};
        // Add the dictionary containing the single form control to a new FormGroup
        this._pageInputs.formGroup = new FormGroup(formControlsGroup);
        // Create the first form control, the search input, and add it to the new group
        this.addNewFormControl();
        // Add the error message for the search control
        this._pageInputs.searchTextErrorLabel = FailOverMappingText.SEARCH_STD_ERR_TXT;
    }
    // Generates a new form control and adds it to the form control group
    addNewFormControl() {
        // Create a new form control
        const selectFormControl = this.generateNewFormControl();
        this.subscribeToControl(selectFormControl);
        // Add the new control to the existing form control group
        this._pageInputs.formGroup.addControl(this.getFormControlKey(), selectFormControl);
    }
    generateNewFormControl(initialState) {
        // Since we're going to create a new form control, we have to increment the index
        this._formControlIndex++;
        // First parameter to FormControl, indicates no initial state for the form on creation
        return new FormControl(initialState, [Validators.required]);
    }
    // Given a FormControl, subscribes an event handler to the value of that formControl changing
    subscribeToControl(control) {
        control.valueChanges
            .pipe(takeUntil(this._formcontrolUnsub))
            // Note that setControlOnChangeEvents() is not actually run at this time, just set as the event handler
            .subscribe((value) => {
            this.setControlOnChangeEvents(control, value);
        }, (err) => {
            console.error(err);
            this._formcontrolUnsub.next();
            this._formcontrolUnsub.complete();
        });
    }
    // Event handler, run whenever the value of the form changes
    setControlOnChangeEvents(control, value) {
        // If this control is the search field, nothing need be done
        if (this.getControlName(control) === this.getFormControlKey(1)) {
            this.clearErrorIfValid(control);
        }
        // Else this is a multiple choice selector and something was just checked
        else {
            this.selectBusinessClassification(control);
        }
    }
    // Given a FormControl, Returns the name of that control in the FormGroup
    getControlName(control) {
        // The line two below only works if the controls are a dictionary of string keys to AbstractControl values.
        //  of course, that's how the FormGroup was set up in this.initializeForm(), see above
        // Grab the controls of the FormGroup
        const formGroup = control.parent.controls;
        // Iterate through keys of dictionary and return the key (that's the string name of the formControl in the form group) whose value is the control passed in
        return Object.keys(formGroup).find((name) => control === formGroup[name]) || null;
    }
    // Clear the overall error if the control is valid
    clearErrorIfValid(control) {
        // Only display form validation errors if the form is invalid AND it has been modified
        //  (obviously a blank form input is invalid but there's no need to display an error for that.)
        if (control.valid || (!control.touched && !control.dirty)) {
            this._pageInputs.searchTextQuestionErrorLabel = null;
        }
    }
    selectBusinessClassification(control) {
        const intentName = control.value;
        if (!intentName || intentName.length === 0) {
            // TODO: Is this the right way to handle this?
            throw new Error('No intentName.');
        }
        // Just for testing invalid sessions
        if (BqxBusinessTypeCLBecaComponentService.BREAK_SESSION) {
            this.breakSession();
        }
        const searchContext = this._pageInputs.selectorQuestions.find((item) => item.QuestionData.Id === this.getControlName(control))
            .QuestionData.context;
        this.onPrimarySearchOptionSelect(intentName, searchContext)
            .pipe(takeUntil(this._onSelectBusinessTypesUnsub))
            .subscribe((selectResponse) => {
            if (this.initialOptions.find((item) => item.name == intentName) && selectResponse.output.response_values) {
                this.initialOptions[this.initialOptions.findIndex((item) => item.name == intentName)].firstOption = selectResponse.output.response_values[0].intent_name;
            }
            this.processPrimaryResponseOnSearch(selectResponse);
        }, (primarySourceErr) => {
            if (this.isInvalidSession(primarySourceErr)) {
                this.handleInvalidSession(`Invalid ClBeca Session. Details: ${primarySourceErr['message']}`);
            }
            else {
                this.fallbackToSecondaryDataSource(FallbackReason.dataSourceError);
            }
            this._onSelectBusinessTypesUnsub.next();
            this._onSelectBusinessTypesUnsub.complete();
        });
    }
    handleInvalidSession(retryReason) {
        this._countInitCallsFailed++;
        console.log('Retry BusinessType Client Initialization', 'Error Reason: ' + retryReason);
        this.initBusinessTypeClient(false);
    }
    breakSession() {
        this._context = 'b9599f5c-e8aa-435f-b90c-87d61b012dee'; // Right format, is not and was never valid (I edited it)
        BqxBusinessTypeCLBecaComponentService.BREAK_SESSION = false;
    }
    // Clears all form controls among other things
    resetBusinessTypeSearch() {
        // this.request = new BecaRequest(); TODO: Secondary Data POST call
        if (this._pageInputs) {
            this._pageInputs.selectorQuestions = new Array();
            this._pageInputs.mayContinue = false;
            // Remove every control except the first (because that's the search input)
            for (let index = 2; index <= this._formControlIndex; index++) {
                this._pageInputs.formGroup.removeControl(this.getFormControlKey(index));
            }
        }
        // Well, now there's only one, so update the index accordingly
        this._formControlIndex = 1;
    }
    searchBusinessTypeFromSecSource(searchText) {
        const secondaryOption = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + this._accessToken
            },
            searchUrl: BQXConfiguration.data.businessTypeSecondaryClientURL,
            requestBody: {
                input: searchText
            }
        };
        // this.isFallback = true;
        return this._SecondaryBusinessTypeRequest.getBusinessTypes(secondaryOption);
    }
    seachBusinessTypeFromPrimarySource(searchText) {
        const primaryOption = this.createClBecaRequest(RequestType.SEARCH, 'StartOver');
        // this.isFallback = false;
        return this._businessTypeRequest.getBusinessTypes(primaryOption).pipe(switchMap((clear) => {
            this._context = clear.context;
            const primaryOption = this.createClBecaRequest(RequestType.SEARCH, searchText);
            return this._businessTypeRequest.getBusinessTypes(primaryOption);
        }));
    }
    onPrimarySearchOptionSelect(choice, serchContext) {
        const option = this.createClBecaRequest(RequestType.SELECT, choice, serchContext);
        return this._businessTypeRequest.getBusinessTypes(option);
    }
    processPrimaryResponseOnSearch(responseBody) {
        const responeObj = {
            context: {
                InitialSearchTerm: this._pageInputs?.formGroup?.value?.FormControl_1,
                conversation_id: responseBody.context.conversation_id,
                guess_count: responseBody.context.guess_count
            },
            output: responseBody.output,
            input: this._serviceData?.data['input']
        };
        this._currentClBecaResponse$.next({ value: responeObj, isFallback: this._inFallbackMode$.value });
        const resObj = this.getBecaResponseObj(responeObj);
        if (resObj instanceof Error) {
            FallbackReason.definedObj = resObj.message;
            this.fallbackToSecondaryDataSource(FallbackReason.userDefObj);
        }
        else {
            this._context = responseBody.context;
            if (resObj.response_type === BecaResponseType.textInput) {
                this.handleTextInputResponse(resObj);
            }
            else if (resObj.response_type === BecaResponseType.multipleChoice) {
                this.handleMultipleChoiceResponse(resObj);
            }
            else if (resObj.response_type === BecaResponseType.finalClassification) {
                this.handleFinalClassificationResponse(resObj);
            }
            else {
                // TODO: Do something with the parsing error
                throw new Error('Unknown error parsing response, format likely unexpected.');
            }
        }
    }
    getBecaResponseObj(responseBody) {
        if (responseBody && responseBody.output) {
            return responseBody.output;
        }
        else {
            return this.getResponseObjError(responseBody);
        }
    }
    // Returns Error object with specific message about responseBody problem
    getResponseObjError(responseBody) {
        const errMsg = 'BECA ERROR: BECA may be down. API output is missing responseBody';
        if (!responseBody) {
            return Error(errMsg);
        }
        else {
            if (!responseBody.output) {
                return Error(errMsg + '.output');
            }
            else {
                throw Error('BECA may be down. API output was not in expected format.');
            }
        }
    }
    isInvalidSession(err) {
        // need to check that err object includes a message at all, to prevent another possible error from being thrown.
        if ('message' in err) {
            return err !== undefined && err['message'].includes(FailOverMappingText.PRIMARY_SOURCE_INVALID_SESSION);
        }
        else {
            return false;
        }
    }
    isTextInputResponseValid(userDefObj) {
        if (!(userDefObj.text && userDefObj.text.length > 0)) {
            return false;
        }
        return true;
    }
    handleTextInputResponse(userDefObj) {
        if (!this.isTextInputResponseValid(userDefObj)) {
            this.fallbackToSecondaryDataSource(FallbackReason.parseMainQuestion);
        }
        else {
            // CASE 1: Search was performed normally and retuned no response
            // This will only occur after a search has been performed,
            // but since it is a string match check, checking it on every text_input response is harmless
            if (userDefObj.text.includes(FailOverMappingText.NO_CLASSIFICATIONS_TEXT)) {
                // The text here is thus an error and needs to be displayed as such, AND the original question is still being asked so it needs to stay in place
                this._pageInputs.searchTextQuestionErrorLabel = userDefObj.text;
                this.incrementSearchesFailed();
                this.setAllowSearch(true);
            }
            // CASE 2: Contractor option selected, and verbiage requiring a more
            // specific business type is received.
            else if (userDefObj.text.includes(FailOverMappingText.MORE_SPECIFIC_PC) ||
                userDefObj.text.includes(FailOverMappingText.TRY_SEARCH_AGAIN_PC)) {
                // adding a blank option here because building the beca question requires an option,
                // but we only need the label to show
                this.addSelectorQuestion(FailOverMappingText.MORE_SPECIFIC_TEXT, FailOverMappingText.TRY_SEARCH_AGAIN_TEXT);
                this.setAllowSearch(false);
            }
            // CASE 3: The user hit the "Clear" button
            else {
                // Technically, this is only an issue if the user types the same search text they typed the first time, but that's not inconceivable
                this._lastSearchText = '';
                this.setAllowSearch(true);
            }
        }
    }
    isMultipleChoiceResponseValid(userDefObj) {
        return (userDefObj.response_values !== undefined &&
            userDefObj.response_values.length !== undefined &&
            userDefObj.response_values.length > 0 &&
            userDefObj.text &&
            userDefObj.text.length > 0);
    }
    parseBusinessCategories(userDefObj) {
        if (!(userDefObj.response_values !== undefined &&
            userDefObj.response_values.length !== undefined &&
            userDefObj.response_values.length >= 0)) {
            const optError = [
                {
                    Value: 'DATA ERROR',
                    Text: 'Business Category Options could not be parsed',
                    Description: 'Business Category Options could not be parsed'
                }
            ];
            return optError;
        }
        else {
            const optResponse = [];
            userDefObj.response_values.forEach((value) => {
                optResponse.push({ Value: value.intent_name, Text: value.label, Description: value.description });
            });
            // return userDefObj.response_values;
            return optResponse;
        }
    }
    // Parses the API response for a multiple choice question
    handleMultipleChoiceResponse(userDefObj) {
        // Since the API is no longer expecting a search request, disallow searches
        this.setAllowSearch(false);
        if (this.isMultipleChoiceResponseValid(userDefObj)) {
            const optMultiChoice = this.parseBusinessCategories(userDefObj);
            if (optMultiChoice[0].Value == 'DATA ERROR') {
                this.fallbackToSecondaryDataSource(FallbackReason.parseBusinessCategories);
            }
            else {
                this.addSelectorQuestion(userDefObj.text, userDefObj.additional_description ? userDefObj.additional_description : '', optMultiChoice);
                this._searchesFailed = 0;
                // this.toggleSessionRenewalText(); TODO:
            }
        }
        else {
            this.incrementSearchesFailed();
        }
    }
    parseFinalClassLabel(resObj) {
        if (!(resObj?.response_values?.length > 0 && resObj?.response_values[0].index_entry && resObj.response_values[0].index_entry.length > 0)) {
            return this.parseFinalClassLabelErrorString(resObj);
        }
        return resObj.response_values[0].index_entry;
    }
    // Returns string with specific error message about userDefObj problem
    parseFinalClassLabelErrorString(userDefObj) {
        const errMsg = 'DATA ERROR: parseFinalClassLabel - API output is missing userDefObj';
        if (!userDefObj) {
            return errMsg;
        }
        else {
            if (userDefObj.response_values.length <= 0) {
                return errMsg + '.response_values';
            }
            else {
                if (!userDefObj.response_values[0].index_entry) {
                    return errMsg + '.response_values.index_entry';
                }
                else {
                    throw new Error('Failed to parse final classification label.');
                }
            }
        }
    }
    parseIntent(resObj) {
        if (!(resObj?.response_values?.length > 0 && resObj?.response_values[0].intent_name && resObj.response_values[0].intent_name.length > 0)) {
            return this.parseIntentErrorString(resObj);
        }
        return resObj.response_values[0].intent_name;
    }
    // Returns string with specific error message about userDefObj problem
    parseIntentErrorString(userDefObj) {
        const errMsg = 'DATA ERROR: parseIntent - API output is missing userDefObj';
        if (!userDefObj) {
            return errMsg;
        }
        else {
            if (userDefObj.response_values.length <= 0) {
                return errMsg + '.response_values';
            }
            else {
                if (!userDefObj.response_values[0].intent_name) {
                    return errMsg + '.response_values.intent_name';
                }
                else {
                    throw new Error('Failed to parse intent.');
                }
            }
        }
    }
    parseFinalClassDescription(resObj) {
        if (!(resObj?.response_values?.length > 0 && resObj.response_values[0].description)) {
            return this.parseFinalClassDescriptionErrorString(resObj);
        }
        return resObj.response_values[0].description;
    }
    // Returns string with specific error message about userDefObj problem
    parseFinalClassDescriptionErrorString(resObj) {
        const errMsg = 'BECA ERROR: parseFinalClassDescription - API output is missing userDefObj';
        if (!resObj) {
            return errMsg;
        }
        else {
            if (resObj.response_values?.lenght <= 0) {
                return errMsg + '.response_values';
            }
            else {
                if (!resObj.response_values[0].description) {
                    return errMsg + '.response_values.description';
                }
                else {
                    throw new Error('Failed to parse final classification description.');
                }
            }
        }
    }
    // Parses the API response for a final classification
    handleFinalClassificationResponse(resObj) {
        // Since the API is no longer expecting a search request, disallow searches
        this.setAllowSearch(false);
        const strFinalClBecaIndexEntry = this.parseFinalClassLabel(resObj);
        const finalIntent = this.parseIntent(resObj);
        if (strFinalClBecaIndexEntry.indexOf('BECA ERROR') !== -1) {
            FallbackReason.parseFinalClassLabel = strFinalClBecaIndexEntry;
            this.fallbackToSecondaryDataSource(FallbackReason.parseFinalClassLabel);
        }
        else {
            // this.request.FinalClBecaIndexEntry = strFinalClBecaIndexEntry; TODO: Secondary Data Post
            const strBECALabel = this.parseFinalClassDescription(resObj);
            if (strBECALabel.indexOf('BECA ERROR') !== -1) {
                FallbackReason.parseFinalClassDescription = strBECALabel;
                this.fallbackToSecondaryDataSource(FallbackReason.parseFinalClassDescription);
            }
            else {
                this._finalClassification$.next({ becaDisplayLabel: this._optionText, code: strFinalClBecaIndexEntry, intent: finalIntent });
                // this.request.BECALabel = this.getBECALabel(strBECALabel);TODO: Secondary Data Post
                // Yes, this really is supposed to be a text description)
                // this.updateAnswerInFrontend(strFinalClBecaIndexEntry);TODO:
            }
        }
        // this.GATrackWalkmeButtons(); TODO:
    }
    // Self-explanatory, will fall back
    incrementSearchesFailed() {
        this._searchesFailed++;
        this._countInitCallsFailed++;
        if (this._searchesFailed >= this._maxSearchCallsAllowed) {
            this.fallbackToSecondaryDataSource(FallbackReason.incrementSearchesFailed);
        }
    }
    fallbackToSecondaryDataSource(fallbackReason, fallbackswitch, iniatlSearchText) {
        if (fallbackswitch) {
            //TODO: Looging
            this.initSecondaryDataSource(iniatlSearchText);
        }
        else {
            if (this._countInitCallsFailed < this._maxInitCallsAllowed) {
                this.handleInvalidSession(fallbackReason);
            }
            else {
                //TODO: Looging
                this.initSecondaryDataSource(iniatlSearchText);
            }
        }
    }
    initSecondaryDataSource(iniatlSearchText) {
        this.resetBusinessTypeSearch();
        this.resetPageInputs();
        // Could specify a custom error text, but the search message works just fine
        const fallbackControl = this.generateNewFormControl(iniatlSearchText);
        this._fallbackControlKey = this.getFormControlKey();
        const fallbackControlUnsubscribe = new Subject();
        // The fallback question contains all of the information needed for the selector,
        //  and also corresponds to the form control being created just above
        this.createFallbackQuestion();
        fallbackControl.valueChanges.pipe(takeUntil(fallbackControlUnsubscribe), debounceTime(500)).subscribe((value) => {
            if (!fallbackControl.errors) {
                this._fallbackFilteredOptions = this.getNaicsPicklistOptions(value);
            }
        }, (err) => {
            console.log('Fallback Data Error: ', err);
            fallbackControlUnsubscribe.next();
            fallbackControlUnsubscribe.complete();
        });
        this._pageInputs.formGroup.addControl(this._fallbackControlKey, fallbackControl);
        this._inFallbackMode$.next(true);
        const fallbackResp = {
            error: 'ClBeca Error',
            initRetryCount: this._countInitCallsFailed,
            searchRetryCount: this._maxSearchCallsAllowed,
            fallBackMode: true,
            fallbackPickListMainLabel: this.pageInputs.fallbackPickListMainLabel,
            fallbackPickListSecondaryLabel: this.pageInputs.fallbackPickListSecondaryLabel
        };
        this._currentClBecaResponse$.next({ value: fallbackResp, isFallback: this._inFallbackMode$.value });
    }
    resetPageInputs() {
        if (this._pageInputs?.formGroup) {
            this._pageInputs.formGroup.removeControl(this.getFormControlKey(1));
        }
        else {
            if (this._pageInputs)
                this._pageInputs.formGroup = new FormGroup({});
            else {
                this.initControlGroup();
                this._pageInputs.formGroup = new FormGroup({});
            }
        }
        this._formControlIndex = 0;
        this._pageInputs.shouldDisplay = true;
    }
    // Generates and adds a new selector question to the template
    // Please read preconditions of called methods
    addSelectorQuestion(questionText, questionHelpText, options) {
        // The element actually has to be generated before the question which it 'holds,' so that the form control indexes are correct
        this.addNewFormControl();
        // The selector question contains all of the information needed for a new multiple-choice Form Control,
        //  and also corresponds to the form control being created just above
        this.createSelectorQuestion(questionText, questionHelpText, options);
    }
    /*
    Creates a multiple-choice BECA question for displaying search results in the template
    REQUIRES:
    - Form Control exists in form group at key this.getFormControlKey(), with index this.formControlIndex;
    */
    createSelectorQuestion(questionText, questionHelpText, options) {
        // If multiple-choice selector has no choices, display an error
        if (options?.length <= 0)
            this._pageInputs.searchTextQuestionErrorLabel = questionText;
        else {
            // Create new BECA question itself
            const selectorQuestion = {
                Code: 'beca_' + this._formControlIndex,
                Status: 'Active',
                Version: 0,
                QuestionData: {
                    FieldType: 'selector',
                    Id: this.getFormControlKey(),
                    Text: questionText,
                    Options: options,
                    IsRequired: true,
                    IsHidden: false,
                    Order: this._formControlIndex,
                    HelpText: questionHelpText,
                    IsMultiSelect: false,
                    context: this._context
                }
            };
            this._pageInputs.searchTextQuestionErrorLabel = null;
            if (this._context.guess_count === 1) {
                this.initialOptions = [];
                selectorQuestion.QuestionData.Options.forEach((val) => {
                    this.initialOptions.push({ name: val.Value });
                });
                this._pageInputs.selectorQuestions = [selectorQuestion];
            }
            else {
                const chosenBusinessType = document.getElementsByTagName('choice-selector-input')[0]?.getElementsByClassName('checked')[0]?.getElementsByTagName('input')[0]?.id;
                if (this.initialOptions.find((item) => item.name === chosenBusinessType)) {
                    if (!selectorQuestion.QuestionData.Options || selectorQuestion.QuestionData.Options[0].Value == this.initialOptions[this.initialOptions.findIndex((item) => item.name == chosenBusinessType)].firstOption) {
                        this._pageInputs.selectorQuestions[1] = selectorQuestion;
                    }
                }
            }
        }
    }
    /*
      Creates a select question
      REQUIRES:
      - Form Control exists in form group at key this.getFormControlKey(), with index this.formControlIndex;
      */
    createFallbackQuestion() {
        this._fallbackQuestion = {
            Code: 'business_type_fallback_' + this._formControlIndex,
            Status: 'Active',
            Version: 1.0,
            QuestionData: {
                FieldType: 'autocomplete',
                Id: this.getFormControlKey(),
                Options: [],
                IsRequired: true,
                IsHidden: false,
                IsMultiSelect: false,
                ErrorMessage: FailOverMappingText.MULT_CHOICE_ERR_MSG,
                Placeholder: 'Please describe your business...'
            }
        };
        this._pageInputs.searchTextQuestionErrorLabel = null;
    }
    // Returns on-the-fly options filtering from the server
    getNaicsPicklistOptions(searchText) {
        if (!searchText) {
            return of(new Array());
        }
        const tempSearchText = this.formatForDynamoStringMatch(searchText);
        if (!tempSearchText) {
            return of(new Array());
        }
        else if (tempSearchText.length < 2) {
            return of(new Array());
        }
        else {
            return this.searchBusinessTypeFromSecSource(tempSearchText).pipe(concatMap((naicsBusinessClassifications) => {
                return of(this._SecondaryBusinessTypeRequest.getBusinessClassifications(naicsBusinessClassifications));
            }));
        }
    }
    formatForDynamoStringMatch(val) {
        try {
            return val.replace(/^./, val[0].toUpperCase());
        }
        catch (error) {
            console.error(error);
            return val;
        }
    }
    createClBecaRequest(type, searcText, context) {
        const headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + this._accessToken
        };
        switch (type) {
            case RequestType.INIT:
                this._serviceData.data['input'] = { text: '' };
                this._serviceData.data['context'] = {
                    conversation_id: '',
                    guess_count: 0
                };
                return {
                    headers: headers,
                    requestBody: this._serviceData.data
                };
            case RequestType.SEARCH:
                this._serviceData.data['input'] = { text: this.sanitizeInput(searcText) };
                this._serviceData.data['context'] = this._context;
                return {
                    headers: headers,
                    requestBody: this._serviceData.data
                };
            case RequestType.SELECT:
                this._serviceData.data['input'] = { text: this.sanitizeInput(searcText) };
                this._serviceData.data['context'] = context;
                return {
                    headers: headers,
                    requestBody: this._serviceData.data
                };
            case RequestType.CLEAN:
                this._serviceData.data['input'] = { text: this.sanitizeInput(searcText) };
                this._serviceData.data['context'] = this._context;
                return {
                    headers: headers,
                    requestBody: this._serviceData.data
                };
            default:
                this._serviceData.data['input'] = { text: '' };
                this._serviceData.data['context'] = {
                    conversation_id: '',
                    guess_count: 0
                };
                return {
                    headers: headers,
                    requestBody: this._serviceData.data
                };
        }
    }
    sanitizeInput(input) {
        return input.replace(/['"]+/g, '');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BqxBusinessTypeCLBecaComponentService, deps: [{ token: i1$1.BusinessTypeRequestsAbstractService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BqxBusinessTypeCLBecaComponentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BqxBusinessTypeCLBecaComponentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$1.BusinessTypeRequestsAbstractService }] });

class BqxBusinessTypeComponentAbstractService {
}

class BusinessTypeClBecaComponent {
    get shouldDisplay() {
        return this.businessTypeComponentService.pageInputs?.shouldDisplay;
    }
    get selctorQuestions() {
        return this.businessTypeComponentService.pageInputs?.selectorQuestions;
    }
    get formGroup() {
        return this.businessTypeComponentService.pageInputs?.formGroup;
    }
    get allowSearch() {
        return this.businessTypeComponentService.pageInputs?.allowSearch;
    }
    get errorText() {
        return this.businessTypeComponentService.pageInputs?.searchTextErrorLabel;
    }
    get customError() {
        return this.businessTypeComponentService.pageInputs?.searchTextQuestionErrorLabel;
    }
    get searchControlLabel() {
        return this.isNotNullOrEmpty(this.headerLabel)
            ? this.businessTypeComponentService.pageInputs?.searchTextQuestionLablel
            : this.headerLabel;
    }
    get searchControlSubLabel() {
        return this.isNotNullOrEmpty(this.headerSubLabel)
            ? this.businessTypeComponentService.pageInputs?.searchTextQuestionSecondaryLabel
            : this.headerSubLabel;
    }
    get seachControlName() {
        return this.businessTypeComponentService.getFormControlKey(1);
    }
    get fallbackControlName() {
        return this.businessTypeComponentService.fallbackControlKey;
    }
    get fallBackfilteredChoices() {
        return this.businessTypeComponentService.fallbackFilteredOptions;
    }
    get fallbackQuestion() {
        return this.businessTypeComponentService.fallbackQuestion;
    }
    get fallbackPickListMainLabel() {
        return this.fallbackHeaderLabel;
    }
    get fallbackPickListSecondaryLabel() {
        return this.fallbackSubHeaderLabel;
    }
    get fallbackPickListSecondaryLabel2() {
        return this.fallbackSubHeaderLabel2;
    }
    get fallbackPickListSecondaryPhone() {
        return this.fallbackSubHeaderPhone;
    }
    get fallbackAssistancePhone() {
        return this.businessTypeComponentService.pageInputs?.fallbackAssistancePhone;
    }
    constructor(businessTypeComponentService, cd) {
        this.businessTypeComponentService = businessTypeComponentService;
        this.cd = cd;
        this.showPrimaryBusinessType$ = new Observable();
        // eslint-disable-next-line @angular-eslint/no-input-rename
        this.data$ = new BehaviorSubject(null);
        // eslint-disable-next-line @angular-eslint/no-output-on-prefix
        this.onFinalClassificationChange = new EventEmitter();
        // eslint-disable-next-line @angular-eslint/no-output-on-prefix
        this.onBecaResultChange = new EventEmitter();
        this.clearButtonPress = new EventEmitter();
        this.textChange = new EventEmitter();
        // eslint-disable-next-line @angular-eslint/no-output-on-prefix
        this.onFocusEmitter = new EventEmitter();
        this._finalClassificationUnsub = new Subject();
        this._currentBecaResultUnsub = new Subject();
        this.fallBackMode$ = new Observable();
        this.subscribetoClBecaEvents();
    }
    subscribetoClBecaEvents() {
        let finalClassification;
        this.businessTypeComponentService.finalClassification$
            .pipe(takeUntilDestroyed(), switchMap((value) => {
            if (value && value !== null) {
                finalClassification = value;
                return this.fallBackMode$;
            }
            else
                return of(false);
        }), map((isFallback) => {
            this.onFinalClassificationChange.emit({ value: finalClassification, isFallback: isFallback });
        }))
            .subscribe();
        this.businessTypeComponentService.currentBecaResult$.pipe(takeUntil(this._currentBecaResultUnsub)).subscribe((value) => {
            if (value && value !== null) {
                this.onBecaResultChange.emit(value);
            }
        });
    }
    ngAfterViewInit() {
        this.cd.detectChanges();
    }
    ngOnInit() {
        this.fallBackMode$ = this.businessTypeComponentService.inFallbackMode$;
        this.data$.subscribe((data) => {
            if (data && data !== null) {
                const { headerLabel, headerSubLabel, fallbackHeaderLabel, fallbackSubHeaderLabel, fallbackSubHeaderPhone, fallbackSubHeaderLabel2 } = data;
                this.headerLabel = headerLabel;
                this.headerSubLabel = headerSubLabel;
                this.fallbackHeaderLabel = fallbackHeaderLabel;
                this.fallbackSubHeaderLabel = fallbackSubHeaderLabel;
                this.fallbackSubHeaderPhone = fallbackSubHeaderPhone;
                this.fallbackSubHeaderLabel2 = fallbackSubHeaderLabel2;
                this.businessTypeComponentService.Initialize(data);
            }
        });
        this.showPrimaryBusinessType$.subscribe((type) => {
            this.businessTypeComponentService.inFallbackMode$.next(!type.show);
            if (!type.show) {
                this.businessTypeComponentService.fallbackToSecondaryDataSource('Show Beca Fallback Requested', !type.show, type.initial_value);
            }
            else {
                const data = this.data$.getValue();
                if (data && data !== null && type.show)
                    this.businessTypeComponentService.Initialize(data);
            }
        });
    }
    onSearchTextChanges() {
        if (!this.businessTypeComponentService.pageInputs.allowSearch) {
            this.businessTypeComponentService.setAllowSearch(true);
        }
    }
    onClear() {
        this.businessTypeComponentService.onClear();
        this.clearButtonPress.emit(null);
    }
    onFocus($event) {
        this.onFocusEmitter.emit($event);
    }
    onChange() {
        this.textChange.emit(null);
    }
    onMatOptionSelected(event) {
        this.businessTypeComponentService.onFallbackOptionSelected(event);
    }
    onSelectorOptionChange(event) {
        this.businessTypeComponentService.clearQuestions(event);
    }
    onSearch() {
        this.businessTypeComponentService.onSearch();
    }
    isNotNullOrEmpty(val) {
        switch (val) {
            case '':
                return true;
            case 'undefined':
                return true;
            case 'null':
                return true;
            case undefined:
                return true;
            case null:
                return true;
            default:
                return false;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BusinessTypeClBecaComponent, deps: [{ token: BqxBusinessTypeComponentAbstractService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.8", type: BusinessTypeClBecaComponent, selector: "businesstype-cl-beca-component", inputs: { showPrimaryBusinessType$: "showPrimaryBusinessType$", data$: ["data", "data$"] }, outputs: { onFinalClassificationChange: "onFinalClassificationChange", onBecaResultChange: "onBecaResultChange", clearButtonPress: "clearButtonPress", textChange: "textChange", onFocusEmitter: "onFocusEmitter" }, providers: [{ provide: BqxBusinessTypeComponentAbstractService, useClass: BqxBusinessTypeCLBecaComponentService }], viewQueries: [{ propertyName: "searchTextInput", first: true, predicate: ["searchTextInput"], descendants: true }, { propertyName: "choiceSelectorInput", first: true, predicate: ["choiceSelectorInput"], descendants: true }, { propertyName: "searchAuotoCompleteInput", first: true, predicate: ["searchAuotoCompleteInput"], descendants: true }], ngImport: i0, template: "<form\n  class=\"bqx-core-business-type-component-form bqx-core-business-type-component-formGroup\"\n  *ngIf=\"shouldDisplay\"\n  [formGroup]=\"formGroup\"\n  (ngSubmit)=\"onSearch()\"\n>\n  <div\n    *ngIf=\"(fallBackMode$ | async) !== true; else fallbackPicklistLabel\"\n    class=\"bqx-core-business-type-component-layout\"\n    id=\"mainAndSecondaryQuestionBox\"\n  >\n    <label\n      class=\"bqx-core-business-type-component-label bqx-core-business-type-component-label-bold\"\n      style=\"display: inline\"\n      for=\"beccaSearch\"\n      [innerHtml]=\"searchControlLabel\"\n    >\n      <!-- {{searchControlLabel}} -->\n    </label>\n    <!-- Subquestion -->\n    <br />\n    {{ searchControlSubLabel }}\n  </div>\n  <ng-template #fallbackPicklistLabel class=\"layout\" id=\"fallbackPicklistLabel\">\n    <!-- The inputs are read by the aria-describedby meaning that this block needs to be hidden else it is ready twice by the screen reader -->\n    <!-- Main Question -->\n    <label\n      class=\"bqx-core-business-type-component-PicklistLabel bqx-core-business-type-component-PicklistLabel-bold\"\n      style=\"display: inline\"\n      for=\"fallBackList\"\n      [innerHtml]=\"fallbackPickListMainLabel\"\n    >\n    </label>\n    <!-- Subquestion -->\n    <div>\n      <span>{{ fallbackPickListSecondaryLabel }}</span>\n      <span>\n        <a\n          [attr.aria-label]=\"fallbackPickListSecondaryLabel + fallbackPickListSecondaryPhone + fallbackPickListSecondaryLabel2\"\n          [href]=\"'tel: +' + fallbackPickListSecondaryPhone\"\n          >{{ fallbackPickListSecondaryPhone }}</a\n        >\n      </span>\n      <span>{{ fallbackPickListSecondaryLabel2 }}</span>\n    </div>\n  </ng-template>\n  <div class=\"bqx-core-business-type-component-PicklistHolder\" *ngIf=\"(fallBackMode$ | async) !== true; else fallbackPicklistHolder\">\n    <!-- Text Input for Search -->\n    <search-text-input\n      #searchTextInput\n      [errorText]=\"errorText\"\n      [customError]=\"customError\"\n      [paramFormGroup]=\"formGroup\"\n      [paramFormControlName]=\"seachControlName\"\n      submitButtonText=\"Search\"\n      resetButtonText=\"Clear\"\n      [showSubmitButton]=\"allowSearch\"\n      (onReset)=\"onClear()\"\n      (input)=\"onSearchTextChanges()\"\n      (focusBeca)=\"onFocus($event)\"\n      (change)=\"onChange()\"\n    >\n    </search-text-input>\n\n    <!-- Multiple choice selectors -->\n    <div *ngFor=\"let question of selctorQuestions\">\n      <div *ngIf=\"question.QuestionData.FieldType === 'selector'\">\n        <choice-selector-input\n          #choiceSelectorInput\n          [paramFormGroup]=\"formGroup\"\n          [labelText]=\"question.QuestionData.Text\"\n          [additionalLabelText]=\"question.QuestionData.HelpText\"\n          [errorText]=\"question.QuestionData.ErrorMessage\"\n          [paramFormControlName]=\"question.QuestionData.Id\"\n          [options]=\"question.QuestionData.Options\"\n          [attr.name]=\"question.QuestionData.Id\"\n          [code]=\"question.Code\"\n          (optionChange)=\"onSelectorOptionChange($event)\"\n        >\n        </choice-selector-input>\n      </div>\n    </div>\n  </div>\n  <ng-template #fallbackPicklistHolder>\n    <search-autocomplete-input\n      #searchAuotoCompleteInput\n      [paramFormGroup]=\"formGroup\"\n      [paramFormControlName]=\"fallbackControlName\"\n      [filteredChoices]=\"fallBackfilteredChoices\"\n      [alias]=\"false\"\n      [require]=\"fallbackQuestion.QuestionData.IsRequired\"\n      [multiple]=\"fallbackQuestion.QuestionData.IsMultiSelect\"\n      (selectedOption)=\"onMatOptionSelected($event)\"\n      [errorText]=\"errorText\"\n      [customError]=\"customError\"\n      (focusFallBack)=\"onFocus($event)\"\n    >\n    </search-autocomplete-input>\n  </ng-template>\n</form>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: SearchTextInputComponent, selector: "search-text-input", inputs: ["errorText", "customError", "paramFormGroup", "paramFormControlName", "submitButtonText", "resetButtonText", "showSubmitButton"], outputs: ["onReset", "focusBeca"] }, { kind: "component", type: ChoiceSelectorInputComponent, selector: "choice-selector-input", inputs: ["paramFormGroup", "labelText", "additionalLabelText", "errorText", "paramFormControlName", "code", "options"], outputs: ["optionChange"] }, { kind: "component", type: SearchAutocompleteInputComponent, selector: "search-autocomplete-input", inputs: ["errorText", "customError", "alias", "require", "multiple", "paramFormGroup", "paramFormControlName", "filteredChoices"], outputs: ["selectedOption", "focusFallBack"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BusinessTypeClBecaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'businesstype-cl-beca-component', providers: [{ provide: BqxBusinessTypeComponentAbstractService, useClass: BqxBusinessTypeCLBecaComponentService }], template: "<form\n  class=\"bqx-core-business-type-component-form bqx-core-business-type-component-formGroup\"\n  *ngIf=\"shouldDisplay\"\n  [formGroup]=\"formGroup\"\n  (ngSubmit)=\"onSearch()\"\n>\n  <div\n    *ngIf=\"(fallBackMode$ | async) !== true; else fallbackPicklistLabel\"\n    class=\"bqx-core-business-type-component-layout\"\n    id=\"mainAndSecondaryQuestionBox\"\n  >\n    <label\n      class=\"bqx-core-business-type-component-label bqx-core-business-type-component-label-bold\"\n      style=\"display: inline\"\n      for=\"beccaSearch\"\n      [innerHtml]=\"searchControlLabel\"\n    >\n      <!-- {{searchControlLabel}} -->\n    </label>\n    <!-- Subquestion -->\n    <br />\n    {{ searchControlSubLabel }}\n  </div>\n  <ng-template #fallbackPicklistLabel class=\"layout\" id=\"fallbackPicklistLabel\">\n    <!-- The inputs are read by the aria-describedby meaning that this block needs to be hidden else it is ready twice by the screen reader -->\n    <!-- Main Question -->\n    <label\n      class=\"bqx-core-business-type-component-PicklistLabel bqx-core-business-type-component-PicklistLabel-bold\"\n      style=\"display: inline\"\n      for=\"fallBackList\"\n      [innerHtml]=\"fallbackPickListMainLabel\"\n    >\n    </label>\n    <!-- Subquestion -->\n    <div>\n      <span>{{ fallbackPickListSecondaryLabel }}</span>\n      <span>\n        <a\n          [attr.aria-label]=\"fallbackPickListSecondaryLabel + fallbackPickListSecondaryPhone + fallbackPickListSecondaryLabel2\"\n          [href]=\"'tel: +' + fallbackPickListSecondaryPhone\"\n          >{{ fallbackPickListSecondaryPhone }}</a\n        >\n      </span>\n      <span>{{ fallbackPickListSecondaryLabel2 }}</span>\n    </div>\n  </ng-template>\n  <div class=\"bqx-core-business-type-component-PicklistHolder\" *ngIf=\"(fallBackMode$ | async) !== true; else fallbackPicklistHolder\">\n    <!-- Text Input for Search -->\n    <search-text-input\n      #searchTextInput\n      [errorText]=\"errorText\"\n      [customError]=\"customError\"\n      [paramFormGroup]=\"formGroup\"\n      [paramFormControlName]=\"seachControlName\"\n      submitButtonText=\"Search\"\n      resetButtonText=\"Clear\"\n      [showSubmitButton]=\"allowSearch\"\n      (onReset)=\"onClear()\"\n      (input)=\"onSearchTextChanges()\"\n      (focusBeca)=\"onFocus($event)\"\n      (change)=\"onChange()\"\n    >\n    </search-text-input>\n\n    <!-- Multiple choice selectors -->\n    <div *ngFor=\"let question of selctorQuestions\">\n      <div *ngIf=\"question.QuestionData.FieldType === 'selector'\">\n        <choice-selector-input\n          #choiceSelectorInput\n          [paramFormGroup]=\"formGroup\"\n          [labelText]=\"question.QuestionData.Text\"\n          [additionalLabelText]=\"question.QuestionData.HelpText\"\n          [errorText]=\"question.QuestionData.ErrorMessage\"\n          [paramFormControlName]=\"question.QuestionData.Id\"\n          [options]=\"question.QuestionData.Options\"\n          [attr.name]=\"question.QuestionData.Id\"\n          [code]=\"question.Code\"\n          (optionChange)=\"onSelectorOptionChange($event)\"\n        >\n        </choice-selector-input>\n      </div>\n    </div>\n  </div>\n  <ng-template #fallbackPicklistHolder>\n    <search-autocomplete-input\n      #searchAuotoCompleteInput\n      [paramFormGroup]=\"formGroup\"\n      [paramFormControlName]=\"fallbackControlName\"\n      [filteredChoices]=\"fallBackfilteredChoices\"\n      [alias]=\"false\"\n      [require]=\"fallbackQuestion.QuestionData.IsRequired\"\n      [multiple]=\"fallbackQuestion.QuestionData.IsMultiSelect\"\n      (selectedOption)=\"onMatOptionSelected($event)\"\n      [errorText]=\"errorText\"\n      [customError]=\"customError\"\n      (focusFallBack)=\"onFocus($event)\"\n    >\n    </search-autocomplete-input>\n  </ng-template>\n</form>\n" }]
        }], ctorParameters: () => [{ type: BqxBusinessTypeComponentAbstractService }, { type: i0.ChangeDetectorRef }], propDecorators: { searchTextInput: [{
                type: ViewChild,
                args: ['searchTextInput']
            }], choiceSelectorInput: [{
                type: ViewChild,
                args: ['choiceSelectorInput']
            }], searchAuotoCompleteInput: [{
                type: ViewChild,
                args: ['searchAuotoCompleteInput']
            }], showPrimaryBusinessType$: [{
                type: Input
            }], data$: [{
                type: Input,
                args: ['data']
            }], onFinalClassificationChange: [{
                type: Output
            }], onBecaResultChange: [{
                type: Output
            }], clearButtonPress: [{
                type: Output
            }], textChange: [{
                type: Output
            }], onFocusEmitter: [{
                type: Output
            }] } });

var bqxBusinesstypeClBeca_component = /*#__PURE__*/Object.freeze({
    __proto__: null,
    BusinessTypeClBecaComponent: BusinessTypeClBecaComponent
});

class BqxBusinessTypeComponentModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BqxBusinessTypeComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.8", ngImport: i0, type: BqxBusinessTypeComponentModule, bootstrap: [BusinessTypeComponent], declarations: [BusinessTypeComponent,
            BusinessTypeClBecaComponent,
            SearchTextInputComponent,
            ChoiceSelectorInputComponent,
            SearchAutocompleteInputComponent,
            BusinessTypeHostDirective], imports: [CommonModule,
            BrowserModule,
            BrowserAnimationsModule,
            ReactiveFormsModule,
            MatAutocompleteModule,
            BqxBusinesstypeRequestsModule], exports: [MatAutocompleteModule, BusinessTypeComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BqxBusinessTypeComponentModule, providers: [{ provide: BusinessTypeRequestsAbstractService, useClass: BusinessTypeRequestsService }, provideHttpClient(withInterceptorsFromDi())], imports: [CommonModule,
            BrowserModule,
            BrowserAnimationsModule,
            ReactiveFormsModule,
            MatAutocompleteModule,
            BqxBusinesstypeRequestsModule, MatAutocompleteModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BqxBusinessTypeComponentModule, decorators: [{
            type: NgModule,
            args: [{ declarations: [
                        BusinessTypeComponent,
                        BusinessTypeClBecaComponent,
                        SearchTextInputComponent,
                        ChoiceSelectorInputComponent,
                        SearchAutocompleteInputComponent,
                        BusinessTypeHostDirective
                    ],
                    exports: [MatAutocompleteModule, BusinessTypeComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    bootstrap: [BusinessTypeComponent], imports: [CommonModule,
                        BrowserModule,
                        BrowserAnimationsModule,
                        ReactiveFormsModule,
                        MatAutocompleteModule,
                        BqxBusinesstypeRequestsModule], providers: [{ provide: BusinessTypeRequestsAbstractService, useClass: BusinessTypeRequestsService }, provideHttpClient(withInterceptorsFromDi())] }]
        }] });

/*
 * Public API Surface of bqx-business-type-component
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BqxBusinessTypeComponentAbstractService, BqxBusinessTypeComponentModule, BusinessTypeComponent };
